import React, { Component } from 'react';

import { localizer } from 'utils/localizer';
import {
    CustomForm,
    CustomInput,
    CustomButton,
    CustomFormFooter,
    CustomFormLayout,
    CustomSelect
} from 'modules/form';

import { createProfile } from './ProfileActions';

import AppStore from 'AppStore';

import './ProfileForm.css';

class ProfileForm extends CustomForm {
    constructor(props) {
        super(props);
        this.provinces = [
            { Alberta: 'Alberta' },
            { 'British Columbia': 'British Columbia' },
            { Manitoba: 'Manitoba' },
            { 'New Brunswick': 'New Brunswick' },
            {
                'Newfoundland and Labrador': 'Newfoundland and Labrador'
            },
            {
                'Northwest Territories': 'Northwest Territories'
            },
            { 'Nova Scotia': 'Nova Scotia' },
            { Nunavut: 'Nunavut' },
            { Ontario: 'Ontario' },
            {
                'Prince Edward Island': 'Prince Edward Island'
            },
            { Quebec: 'Quebec' },
            { Saskatchewan: 'Saskatchewan' },
            { Yukon: 'Yukon' }
        ];
    }
    onSubmitHandler = () => {
        if (this.isFormValid()) {
            const form = this.serializeForm();

            const authUser = AppStore.getAuth().user;
            const user = {};
            user.email = authUser.email;
            user.country = 'Canada';
            user.userType = authUser.role;
            user.portalId = authUser._id;

            const profile = Object.assign({}, form, user);

            createProfile(profile);
        }
    };

    render() {
        return (
            <div className="profile-form">
                <CustomFormLayout>
                    <CustomInput
                        name="firstName"
                        type="text"
                        label={localizer.FIRST_NAME}
                        placeholder={localizer.FIRST_NAME_PLACEHOLDER}
                        form={this}
                    />
                    <CustomInput
                        name="lastName"
                        type="text"
                        label={localizer.LAST_NAME}
                        placeholder={localizer.LAST_NAME_PLACEHOLDER}
                        form={this}
                    />
                    <CustomInput
                        name="phone"
                        type="text"
                        label={localizer.PHONE}
                        placeholder={localizer.PHONE_PLACEHOLDER}
                        form={this}
                    />
                    <CustomInput
                        name="street"
                        type="text"
                        label={localizer.ADDRESS}
                        placeholder={localizer.ADDRESS_PLACEHOLDER}
                        form={this}
                    />
                    <CustomInput
                        name="city"
                        type="text"
                        label={localizer.CITY}
                        placeholder={localizer.CITY_PLACEHOLDER}
                        form={this}
                    />
                    <CustomSelect
                        name="province"
                        type="text"
                        label={localizer.PROVINCE}
                        placeholder={localizer.PROVINCE_PLACEHOLDER}
                        form={this}
                        options={this.provinces}
                    />
                    <CustomInput
                        name="postalCode"
                        type="text"
                        label={localizer.POSTAL_CODE}
                        placeholder={localizer.POSTAL_CODE_PLACEHOLDER}
                        form={this}
                    />
                    <CustomInput
                        name="companyName"
                        type="text"
                        label={localizer.COMPANY_NAME}
                        placeholder={localizer.COMPANY_NAME_PLACEHOLDER}
                        form={this}
                    />
                    <CustomInput
                        name="title"
                        type="text"
                        label={localizer.JOB_TITLE}
                        placeholder={localizer.JOB_TITLE_PLACEHOLDER}
                        form={this}
                    />

                    <CustomFormFooter>
                        <CustomButton
                            align="right"
                            type="primary-button"
                            action={this.onSubmitHandler}
                            label={localizer.SAVE}
                            loading={this.props.loadingState}
                        />
                    </CustomFormFooter>
                </CustomFormLayout>
            </div>
        );
    }
}

export default ProfileForm;



// WEBPACK FOOTER //
// ./src/modules/profile/ProfileForm.jsx